import React, { Component } from "react";
import _, { get } from "lodash";
import htmlParser from "html-react-parser";
import Dropzone from "../FileUpload/Dropzone";
import styles from "../FileUpload/UploadFiles.module.scss";
import Select from "react-select";
import {
  ERR,
  UPLOADED,
  VALID_FILE_TYPE,
  MAX_REPORTS_SIZE,
  MAX_SIZE_IN_MB,
} from "../FileUpload/constant";
import { ReactComponent as DownArrowLine } from "../../assets/SVGs/download-arrow-line.svg";
import { ReactComponent as TrashIcon } from "../../assets/SVGs/delete.svg";
import Progress from "../FileUpload/Progress";
import popupStyles from "./Extraa.module.scss";
import { distributorSelectStyle } from "./selectStyle";
import { ReactComponent as Xclose } from "../../assets/SVGs/x-close.svg";
import { ReactComponent as HelpIcon } from "../../assets/SVGs/help-icon.svg";
import ReactModal from "react-modal";
import Button2 from "../Button2";

class SingleFileUploadFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      uploadProgress: {},
      successUploadCount: 0,
      isRename: false,
      isOpen: false,
      isContactOpen: false,
      inputValue: "",
      isUpdated: false,
      findReportModal: false,
      selectedDistributor: null,
    };
    this.uploadRef = React.createRef();
  }

  resetState = (additionalStates = {}) => {
      this.setState({
        files: [],
        uploadProgress: {},
        successUploadCount: 0,
        isRename: false,
        isOpen: false,
        isContactOpen: false,
        inputValue: "",
        isUpdated: false,
        findReportModal: false,
        selectedDistributor: null,
        ...additionalStates,
      });
    };

  componentDidMount() {
    this.setState({
      selectedDistributor:
        _.find(get(this.props, "selectOptions"), {
          label: get(this.props, "distributorInfo.name"),
        }) ||
        _.find(get(this.props, "selectOptions"), {
          value: "",
        }),
    });

    if (this.props.initialFiles?.length) {
      const uploadProgress = {};
      const { initialFiles } = this.props;
      initialFiles.forEach((file) => {
        uploadProgress[file.name] = {
          state: UPLOADED,
          percentage: 100,
        };
      });
      this.setState({
        uploadProgress: uploadProgress,
        files: initialFiles,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const current = this.uploadRef.current;
    current.scrollTop = current.clientHeight - current.scrollHeight;
    if (
      get(prevProps, "distributorInfo._id") !==
      get(this.props, "distributorInfo._id")
    ) {
      this.setState({
        selectedDistributor:
          _.find(get(this.props, "selectOptions"), {
            label: get(this.props, "distributorInfo.name"),
          }) ||
          _.find(get(this.props, "selectOptions"), {
            value: "",
          }),
      });
    }
  }

  onFilesAdded = (files) => {
    const fileList = files.filter(
      (file) => !this.state.uploadProgress[file.name]
    );
    const uploadProgress = this.state.uploadProgress;
    fileList.forEach((file) => {
      const fileExtension = file.name.split(".");
      if (file.size > MAX_REPORTS_SIZE) {
        uploadProgress[file.name] = {
          state: ERR,
          percentage: 100,
          msg: `File size exceeded (${MAX_SIZE_IN_MB}MB)`,
        };
      } else if (
        fileExtension.length < 2 ||
        VALID_FILE_TYPE.indexOf(fileExtension.pop().toLowerCase()) === -1
      ) {
        uploadProgress[file.name] = {
          state: ERR,
          percentage: 100,
          msg: "File type not accepted",
        };
      } else {
        uploadProgress[file.name] = {
          state: UPLOADED,
          percentage: 100,
        };
        this.props.updateFileList(file, false);
      }
    });
    this.setState((prevState) => ({
      uploadProgress: uploadProgress,
      files: prevState.files.concat(fileList),
    }));
  };

  deleteFile = (file) => {
    const { uploadProgress, files } = this.state;
    delete uploadProgress[file.name];
    _.remove(files, (f) => f.name === file.name);
    this.setState({
      uploadProgress,
      files,
    });
    this.props.updateFileList(file, true);
  };

  renderProgress = (file) => {
    const uploadProgress = this.state.uploadProgress[file.name];
    return (
      <div
        className={`${styles.progressWrapper} ${
          [UPLOADED, ERR].indexOf(get(uploadProgress, "state", "")) !== -1
            ? styles.dNone
            : ""
        }`}
      >
        <>
          <Progress
            progress={uploadProgress.percentage || 0}
            status={uploadProgress.state}
          />
        </>
      </div>
    );
  };

  renderFileList = () => (
    <div className={styles.upload}>
      <div className={styles.content}>
        <div className={styles.files}>
          {this.state.files.map((file, index) => {
            const uploadProgress = this.state.uploadProgress[file.name];
            return (
              uploadProgress && (
                <div
                  key={`${file.name}-${index}`}
                  className={`${styles.row} ${
                    uploadProgress.state === ERR ? styles.error : ""
                  }`}
                  title={file.name}
                >
                  <div className={styles.fileNameContainer}>
                    <p className={styles.fileName}>{file.name}</p>
                    <div
                      className={`${styles.checkIcon} ${
                        (uploadProgress.percentage === 100 &&
                          this.props.loading)
                          ? styles.dNone
                          : ""
                      }`}
                      onClick={() => {
                        this.deleteFile(file);
                      }}
                    >
                      <TrashIcon />
                    </div>
                  </div>
                  {get(this.state.uploadProgress[file.name], "msg") && (
                      <p className={styles.msgError}>
                        {get(this.state.uploadProgress[file.name], "msg")}
                        <i
                          className={`${styles.helpBtn} fa fa-question-circle`}
                          onClick={() => {
                            this.setState({ isContactOpen: true });
                          }}
                          title={`Help`}
                        ></i>
                      </p>
                    )}
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );

  infoDistributorText = () =>
    get(this.props, "distributorInfo.name") && (
      <>
        {" "}
        from{" "}
        <span className="textBold">
          {get(this.props, "distributorInfo.name")}
        </span>
      </>
    );

  handleFindReportModal = (value) => {
    this.setState({ findReportModal: value });
  };

  renderFindReportModal = () => {
    const { distributorInfo } = this.props;
    return (
      <ReactModal
        isOpen={this.state.findReportModal}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        appElement={document.getElementById('root') || undefined}
        onRequestClose={() => this.handleFindReportModal(false)}
        className={styles.findReportPopupContainer}
        overlayClassName={styles.modalOverlay}
        bodyOpenClassName={styles.hideOverflow}
      >
        <div className={`${styles.instructionInfoContainer}`}>
          {get(distributorInfo, "name") === "other" ||
          get(distributorInfo, "") ? (
            <div className={styles.otherContent}>
              <h4 className={styles.infoTitle}>
                What Reports are We Looking For?{" "}
                <Xclose onClick={() => this.handleFindReportModal(false)} />
              </h4>
              <p>
                We are looking for an excel-type file (csv, tsv, xls, etc) with
                detailed data that shows at least:
              </p>
              <ul>
                <li>Track Title &amp; Artist Name</li>
                <li>Track ISRC</li>
                <li>Number of Streams</li>
                <li>Date those streams occurred</li>
                <li>Revenue generated by each of those streams</li>
                <li>Platform where those streams occurred</li>
                <li>Country where those streams occurred</li>
              </ul>
            </div>
          ) : (
            <>
              <h4 className={styles.infoTitle}>
                How to get your {get(distributorInfo, "name", "")} reports{" "}
                <Xclose onClick={() => this.handleFindReportModal(false)} />
              </h4>
              <div className={styles.instructionsContent}>
                {htmlParser(get(distributorInfo, "instructionsHTML", ""))}
              </div>
              <>
                <a
                  className={styles.btnLink}
                  href={get(distributorInfo, "instructionsUrl")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DownArrowLine />
                  <span>Download Detailed Instructions (PDF)</span>
                </a>
              </>
            </>
          )}
        </div>
      </ReactModal>
    );
  };

  handleClose = () => {
    this.props.handleClose();
  };

  render() {
    const { distributorInfo } = this.props;
    return (
      <div className={popupStyles.uploadModalContent} ref={this.uploadRef}>
        <div className={popupStyles.logoDetails}>
          <label>{this.props.label || "Select a Distributor to Upload Reports:"}</label>
          <Select
            classNamePrefix="distributor"
            styles={distributorSelectStyle}
            onChange={this.props.onChange}
            options={this.props.selectOptions}
            placeholder={this.props.placeholder || "Select Your Main Distributor"}
            value={this.state.selectedDistributor}
            components={{ IndicatorSeparator: null }}
            formatOptionLabel={(val) => (
              <div className={popupStyles.option}>
                {get(val, "logoUrl") && (
                  <img
                    src={get(val, "logoUrl")}
                    alt={`${get(val, "label")}-logo`}
                  />
                )}{" "}
                <p>{get(val, "label")}</p>
              </div>
            )}
            isLoading={this.props.loading}
          />
        </div>
        {(get(distributorInfo, "name") !== '')  && (
            <div className={popupStyles.infoAndUploadContainer}>
              <Button2
                type="button"
                lg
                linkButton
                onClick={() => this.handleFindReportModal(true)}
                className={popupStyles.instructionToggle}
              >
                <HelpIcon /> <p>Can't find your reports?</p>
              </Button2>
              <div ref={this.uploadRef}
                className={`${styles.uploadContainer}`}
              >
                <Dropzone
                  disabled={this.props.loading}
                  onFilesAdded={this.onFilesAdded}
                  successUploadCount={this.state.successUploadCount}
                />
                {this.renderFileList()}
                {this.renderFindReportModal()}
              </div>
            </div>
        )}
        
      </div>
    );
  }
}

export default SingleFileUploadFiles;
